export default __webpack_public_path__ + "static/601106758a37406fce8b48efdbcaacee.svg";